import { jsx } from 'react/jsx-runtime';
import { NoSsr } from '@fabric-app/ui/components/NoSSR';
import { UploadDevToolsBase } from './UploadDevToolsBase.js';

const UploadDevTools = () => {
  return /* @__PURE__ */ jsx(NoSsr, {
    children: /* @__PURE__ */ jsx(UploadDevToolsBase, {})
  });
};

export { UploadDevTools };
//# sourceMappingURL=UploadDevTools.js.map
